import { ApolloLink } from '@apollo/client';
import { getImpersonationUid, isImpersonating } from '../helpers/impersonationHelpers';

type Headers = {
  authorization?: string;
};

const authLink = new ApolloLink((operation, forward) => {
  const accessToken = localStorage.getItem('token');

  operation.setContext(({ headers }: { headers: Headers }) => ({
    headers: {
      ...headers,
      authorization: accessToken ? `Bearer ${accessToken}` : '',
      ...(isImpersonating() && { 'Impersonate-Uid': getImpersonationUid() })
    }
  }));

  return forward(operation);
});

export { authLink };
